module.exports = __webpack_public_path__ + "static/media/SarahSwitek_03_HowAreYouFeeling-Confirmation_4.fa57a495.mp3";